import { getCoordinatorApi } from "@/lib/api";

export const createApiKey = async ({
  projectId,
  label,
  organizationId,
  expiresAt,
}: {
  projectId: string;
  label: string;
  organizationId: string;
  expiresAt?: string;
}) => {
  const api = getCoordinatorApi({ organizationId, projectId });
  const body: { label: string; expires_at?: string } = {
    label,
    ...(expiresAt && { expires_at: expiresAt }),
  };

  const { data } = await api.post("/api_keys", body);
  return data;
};
